/**
 * MCP server toggle API client.
 */
import { api } from '@/api/client';

export interface MCPServerInfo {
  name: string;
  display_name: string;
  description: string;
  repo?: string | null;
  enabled: boolean;
  known: boolean;
}

export interface MCPListResponse {
  agent: string;
  items: MCPServerInfo[];
}

export const mcpsApi = {
  async list(agent: string): Promise<MCPListResponse> {
    return api<MCPListResponse>(`/agents/${encodeURIComponent(agent)}/mcps`);
  },

  async toggle(agent: string, mcpName: string, enabled: boolean): Promise<{ ok: boolean }> {
    return api<{ ok: boolean }>(
      `/agents/${encodeURIComponent(agent)}/mcps/${encodeURIComponent(mcpName)}`,
      {
        method: 'PUT',
        body: { enabled },
      },
    );
  },
};
